module.exports = __webpack_public_path__ + "static/media/logo-blanco.69cec333.svg";